<template>
  <div :id="widgetStyle">
    <router-view/>
  </div>
</template>

<script>

import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  name: 'App',
  setup() {
    const router = useRouter();
    const widgetStyle = ref('widget-default');
    onMounted(async () => {
      await router.isReady();
      const style = router.currentRoute?.value?.query?.style;

      if (style?.length > 0)
        widgetStyle.value = 'widget-' + style;
      else if (localStorage?.getItem('style'))
        widgetStyle.value = localStorage.getItem('style');

      localStorage?.setItem('style', widgetStyle.value);

      if (localStorage?.getItem('style') === 'widget-ocarina')
        import('../public/css/ocarina.css');
      else if (localStorage?.getItem('style') === 'widget-alteo')
        import('../public/css/alteo.css');
      else if (localStorage?.getItem('style') === 'widget-eneo')
        import('../public/css/eneo.css');
      else if (localStorage?.getItem('style') === 'widget-eneo-sport')
        import('../public/css/eneo_sport.css');
      else if (localStorage?.getItem('style') === 'widget-default')
        import('../public/css/default.css');
      else
        localStorage?.removeItem('style');
    });

    return {widgetStyle}
  }
}
</script>
